export { default } from "./Product";



// WEBPACK FOOTER //
// ./src/components/Product/index.js